import {
  createSelector,
  createSlice,
  type PayloadAction
} from "@reduxjs/toolkit";
import type { CookieConsentState } from "../../services/cookieConsent/types";
import type { RootState } from "../store";

export type ConsentState = {
  consent: CookieConsentState;
  showBanner: boolean;
  isBrowserMode: boolean;
};

export const initialConsentState: ConsentState = {
  consent: { isResolved: false, analytics: false, functional: false },
  showBanner: false,
  isBrowserMode: false
};

const consentSlice = createSlice({
  name: "consent",
  initialState: initialConsentState,
  reducers: {
    consentInitialisationRequested: () => {},
    consentResolved: (state, action: PayloadAction<CookieConsentState>) => {
      state.consent = action.payload;
    },
    browserModeDetected: (state) => {
      state.isBrowserMode = true;
    },
    bannerShown: (state) => {
      state.showBanner = true;
    },
    consentChosen: (
      state,
      action: PayloadAction<{ analytics: boolean; functional: boolean }>
    ) => {
      state.consent = {
        isResolved: true,
        analytics: action.payload.analytics,
        functional: action.payload.functional
      };
      state.showBanner = false;
    },
    bannerReopened: (state) => {
      state.showBanner = true;
    }
  }
});

export const {
  consentInitialisationRequested,
  consentResolved,
  browserModeDetected,
  bannerShown,
  consentChosen,
  bannerReopened
} = consentSlice.actions;

export const selectConsent = (state: RootState): CookieConsentState =>
  state.consent.consent;
export const selectShowBanner = (state: RootState): boolean =>
  state.consent.showBanner;
const selectIsBrowserMode = (state: RootState): boolean =>
  state.consent.isBrowserMode;
export const selectCanManagePreferences = createSelector(
  [selectIsBrowserMode, selectConsent],
  (isBrowserMode, consent) => isBrowserMode && consent.isResolved
);

export const consentReducer = consentSlice.reducer;
export default consentReducer;
